import React, {useEffect, useState, useRef} from "react";
import { CardGroup} from "react-bootstrap";
import {useCartContext} from "../../Context/CartContext";
import { salesOrderAPI, pageInfoAPI} from "../../api/api";
import {ParseDate} from "../../common/Helpers/jsHelpers";
import {paymentTypeList, shippingMethodList, getAccountingTypeList} from "../../common/constants";
import {useNavigate} from "react-router-dom";
import styleCart from './Cart.module.css'
import {Toast} from "primereact/toast";
import {DiscountProgressBar} from '../DiscountProgressBar/DiscountProgressBar';
import "./Cart.css"
import styles from "../Catalog/Catalog.module.css";
import { SpinnerUA } from "../../common/Spinners/SpinerUA/SpinnerUA";
import {ConfirmPopup} from "primereact/confirmpopup";
import {Dialog} from "primereact/dialog";
import {Button} from "primereact/button";
import { Panel } from 'primereact/panel';
import { InputTextarea } from "primereact/inputtextarea";
import { Dropdown } from 'primereact/dropdown'
import { Calendar } from 'primereact/calendar';
import { Messages } from 'primereact/messages';
import {MarketingStockTypesEnum} from '../../common/constants'
import { Tooltip } from 'primereact/tooltip';
import {clearCartRequiredField} from "../../common/Helpers/storageHelper";
import { MarketingStockCalculator } from "../MarketingStock/MarketingStockCalculator/MarketingStockCalculator";
import {CartStockSetItem} from "./CartStockSetItem/CartStockSetItem"
import {CartProductNew} from "../Product/CartProductNew/CartProductNew";
import {Tag} from "primereact/tag";
import {FloatLabel} from "primereact/floatlabel";
import { classNames } from 'primereact/utils';

export const Cart = () => {

    const msgs = useRef(null);
    const balanceMessageRef = useRef(null);

    const [okpo, setOkpo] = useState('');
    const [accountingTypeList, setAccountingTypeList] = useState([]);

    const [isVisible, setIsVisible] = useState(false);
    const [isFirstLoading, setIsFirtsLoading] = useState(true);
    const [isLoading, setIsLoading] = useState(true);
    
    const [allProductPriceAmount, setAllProductPriceAmount] = useState(0);
    const [allProductProfit, setAllProductProfit] = useState(0);
    const [saveAmount, setSaveAmount] = useState(0);
    const [products, setProducts] = useState([]);
    const [stockList, setStockList] = useState([]);
    const [crmMessage, setCrmMessage] = useState('');

    const {cart, getCart, clearCart, setInitCart} = useCartContext();

    const [discountLabel, setDiscountLabel] = useState('');
    const [discountPercent, setDiscountPercent] = useState("");
    const [isDiscountGoalAchieved, setIsDiscountGoalAchieved] = useState(false);
    const [countLitersToDiscount, setCountLitersToDiscount] =  useState(0);
    const [currentLitersToDiscount, setCurrentLitersToDiscount] =  useState(0);

    //CheckAvailability
    const [productAvailabilityList, setProductAvailabilityList] = useState([]);

    const clearCartBtn = useRef(null);
    const navigate = useNavigate()
    //modal info
    const [show, setShow] = useState(false);
    const [clearCartConfirmVisible, setClearCartConfirmVisible] = useState(false);
    const [discountModalVisible, setDiscountModalVisible] = useState(false);
    const toast = useRef(null);

    //data from CRM
    const [accountDeliveryAddressList, setAccountDeliveryAddressList] = useState([]);
    const [isDebtOverdue, setIsDebtOverdue] = useState(false);

    //state для создания заказа
    //const [selectedAccountDeliveryAddressId, setSelectedAccountDeliveryAddressId] = useState('')
    const [selectedAccountDeliveryAddress, setSelectedAccountDeliveryAddress] = useState(null)
    const [salesOrderId, setSalesOrderId] = useState('');
    const [requestDeliveryBy, setRequestDeliveryBy] = useState('');
    const [shippingMethodCode, setShippingMethodCode] = useState();
    const [accountingType, setAccountingType] = useState(null);
    const [accountingTypeCode, setAccountingTypeCode] = useState(null);
    const [paymentTypeCode, setPaymentTypeCode] = useState();
    const [note, setNote] = useState('');

    const [minDate, setMinDate] = useState(null)
    //успешно ли создан заказ.
    const [isSuccess, setIsSuccess] = useState(false);

    useEffect(() => {
        if(isDebtOverdue){
            if (msgs.current) {
                msgs.current.clear();
                msgs.current.show([
                    { sticky: true, severity: 'info', summary: '', detail: 'У вас є неоплачені рахунки згідно з умовами оплати. Просимо сплатити протерміновану заборгованість.', closable: false},
                ]);
            }
        }
    }, [isDebtOverdue])

    useEffect(() => {
        if(productAvailabilityList && productAvailabilityList.length > 0 && balanceMessageRef.current){
            balanceMessageRef.current.scrollIntoView({
                behavior: "smooth",
                block: "center", // центрирует по вертикали
              });
        }
    }, [productAvailabilityList, balanceMessageRef.current])

    //useEffect for req fields
    //accountingType
    useEffect(() => {
        if(accountingType === null && accountingTypeList.length > 0){
            try {
                const savedAccountingType = JSON.parse(sessionStorage.getItem('accountingType'))
                if (savedAccountingType) {
                    let contains = accountingTypeList.some(item => JSON.stringify(item) === JSON.stringify(savedAccountingType));
                    if(contains){
                        setAccountingType(savedAccountingType)
                    }
                }
            }
            catch (ex){
                console.log('set accountingType error' + ex);
            }
        }

    }, [accountingTypeList]);

    //accountDeliveryAddress
    useEffect(() => {
        if(selectedAccountDeliveryAddress === null && accountDeliveryAddressList.length > 0){
            try {
                const savedDeliveryAddress = JSON.parse(sessionStorage.getItem('accountDeliveryAddress'))
                if (savedDeliveryAddress) {
                    let contains = accountDeliveryAddressList.some(item => JSON.stringify(item) === JSON.stringify(savedDeliveryAddress));
                    if(contains){
                        setSelectedAccountDeliveryAddress(savedDeliveryAddress)
                    }
                }
            }
            catch (ex){
                console.log('set accountDeliveryAddress error' + ex);
            }
        }

    }, [accountDeliveryAddressList]);

    //requestDeliveryBy
    useEffect(() => {
        if(!requestDeliveryBy){
            try{
                const savedDeliveryBy = new Date( JSON.parse(sessionStorage.getItem('requestDeliveryBy')) )
                if(savedDeliveryBy){
                    let today = new Date();
                    today.setHours(0, 0, 0, 0);
                    if(savedDeliveryBy > today) {
                        setRequestDeliveryBy(savedDeliveryBy)
                    }
                }
            }
            catch (ex){
                console.log('set deliveryBy error' + ex);
            }
        }
    }, [requestDeliveryBy]);

    //modal info
    const handleClose = async () => {
        setShow(false);
        await setInitCart();

        if (isSuccess) {
            clearCartRequiredField();
            navigate("/history")
        }
    }

    const handleCloseDiscountModal = () => {
        setDiscountModalVisible(false);
    }

    const handleShow = () => setShow(true);

    const createSalesOrderButtonClickHandler = async () => {
        if(!validateRequestDeliveryBy()){
            toast.current.clear()
            toast.current.show({severity: 'warn', summary: 'Помилка', detail: "Оберіть дату поставки", life: 3000});
            return
        }

        if(selectedAccountDeliveryAddress == null)
        {
            toast.current.clear()
            toast.current.show({severity: 'warn', summary: 'Помилка', detail: "Оберіть адресу доставки", life: 1000});
            return;
        }

        if(accountingType == null)
        {
            toast.current.clear()
            toast.current.show({severity: 'warn', summary: 'Помилка', detail: "Оберіть спосіб оплати", life: 1000});
            return;
        }
        if(!isDiscountGoalAchieved && currentLitersToDiscount > 0){
            setDiscountModalVisible(true)
        }
        else{
            createSalesOrderHandler().then();
        }
    }

    const createSalesOrderWithoutDiscount = async () => {
        setDiscountModalVisible(false)
        createSalesOrderHandler().then();
    }

    const navigateToCatalog = () => {
        navigate("/catalog")
    }
    const createSalesOrderHandler = async () => {
        debugger
        const createSalesOrderObject = {
            RequestDeliveryBy: requestDeliveryBy,
            AddressDeliveryId: selectedAccountDeliveryAddress.Id,
            AccountingTypeCode: accountingType.Value,
            NoteOrder: note,
        }

        setIsLoading(true);
        const {data} = await salesOrderAPI.create(JSON.stringify(createSalesOrderObject));
        setIsLoading(false);
        const resp = JSON.parse(data);

        //Выводим сообщение для пользователя о состоянии заказа или ошибке
        setCrmMessage(resp.message);
        setShow(true);


        //устанавливаем состояние создания заказа. Если false - остаёмся на странице создания заказа
        setIsSuccess(resp.isSucccess);
    }

    const setMinDateForDelivery = () => {
        let today = new Date();
        let tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate() + 1);
        setMinDate(tomorrow)
    }

    const validateRequestDeliveryBy = () => {

        return requestDeliveryBy !== '' && requestDeliveryBy !== null;
    }
    const reqDelByHandler = async (e) => {
        console.log(e.target)
        const date = ParseDate(e.target.value)
        setRequestDeliveryBy(date);

        sessionStorage.setItem('requestDeliveryBy', JSON.stringify(date))
    }
    const shippingMethodHandler = async (e) => {
        setShippingMethodCode(shippingMethodList[e.target.selectedIndex].value)
    }

    const deliveryAddressHandler = (e) => {
        setSelectedAccountDeliveryAddress(e.target.value);
        sessionStorage.setItem('accountDeliveryAddress', JSON.stringify(e.target.value))
    }
    const accountingTypeHandler = (e) => {
        setAccountingType(e.target.value)
        sessionStorage.setItem('accountingType', JSON.stringify(e.target.value))
    }
    const paymentTypeHandler = async (e) => {
        setPaymentTypeCode(paymentTypeList[e.target.selectedIndex].value)
    }

    const fetchDateForPageFromCRM = async () => {

        const {data} = await pageInfoAPI.getInfoForCartPage()

        let resp = JSON.parse(data);
        if(resp.isSucccess){
            //deliveryAddress
            setAccountDeliveryAddressList(resp.data.AccountDeliveryAddressList);
            if(resp.data.length > 0 ){
                setSelectedAccountDeliveryAddressId(resp.data[0].Id)
            }

            //flag IsDebtOverdue
            setIsDebtOverdue(resp.data.IsDebtOverdue)
        }
        else{
            toast.current.clear()
            toast.current.show({severity: 'error', summary: 'Помилка', detail: 'При завантаженні даних з бази виникла помилка: '+ resp.data.message, life: 3000});
        }
        setIsFirtsLoading(false);
    }
    const setDefCode = () => {
        setShippingMethodCode(shippingMethodList[0].value)
        //setAccountingTypeCode(accountingTypeList[0].value)
        setPaymentTypeCode(paymentTypeList[0].value)
    }

    useEffect(() => {

        setMinDateForDelivery();

        const acTypeList = getAccountingTypeList(okpo)
        setAccountingTypeList(acTypeList);

        setDefCode();
        fetchDateForPageFromCRM().then(() => {setIsLoading(false);});
        //setIsLoading(false);
        setTimeout(() => {
            setIsVisible(true)
        },0)
    }, [])


    useEffect(() => {
        if (cart) {
            const cart = JSON.parse(getCart());

            //check balance product in cart
            setProductAvailabilityList(cart.CartMoreAvailableProductBalanceModel)
            console.log(`CartMoreAvailableProductBalanceModel: `, cart.CartMoreAvailableProductBalanceModel)

            //% скидки
            let discountModel = cart.DiscountModel
            setDiscountLabel("-"+ discountModel.DiscountPercent + "%");

            //цель достигнута
            const isGoalAchieved = cart.CurrentLitersToDiscount >= cart.DiscountModel.DiscountCondition
            setIsDiscountGoalAchieved(isGoalAchieved)

            //
            try{
                setDiscountPercent(cart.DiscountModel.DiscountPercent + "%")
                setCurrentLitersToDiscount(cart.CurrentLitersToDiscount);
                setCountLitersToDiscount(cart.DiscountModel.DiscountCondition - cart.CurrentLitersToDiscount)
            }
            catch {}


            const okpo = cart.oCode;
            var acTypeList = getAccountingTypeList(okpo)
            setAccountingTypeList(acTypeList);
            setAccountingTypeCode(null)

            const prods = cart.BaseOrder;
            const stocks = cart.Stocks;

            setProducts(prods);
            setStockList(stocks);
            setSaveAmount(cart.SavedAmount);

            //общая цена и выгода
            let amount = 0;
            let profit = 0;
            let amountWithRecPrice = 0; //для расчёта профита

            //base Order
            for (let i = 0; i < prods.length; i++) {
                const priceIndex = prods[i].priceListIndex
                amount += parseFloat(parseFloat(prods[i].priceList[priceIndex].UoMPrice).toFixed(2) * parseFloat(prods[i].count).toFixed());
                profit += parseFloat(parseFloat(prods[i].recommendPrice).toFixed(2) * parseFloat(prods[i].count).toFixed());
                if(prods[i].recommendPrice !== 0){
                    amountWithRecPrice += parseFloat(parseFloat(prods[i].priceList[priceIndex].UoMPrice).toFixed(2) * parseFloat(prods[i].count).toFixed());
                }
            }

            //stocks products
            stocks.forEach(stock => {

                stock.ProductList.forEach(product => {
                    const priceIndex = product.priceListIndex
                    amount += parseFloat(parseFloat(product.priceList[priceIndex].UoMPrice).toFixed(2) * parseFloat(product.count).toFixed());
                    profit += parseFloat(parseFloat(product.recommendPrice).toFixed(2) * parseFloat(product.count).toFixed());
                    if(product.recommendPrice !== 0){
                        amountWithRecPrice += parseFloat(parseFloat(product.priceList[priceIndex].UoMPrice).toFixed(2) * parseFloat(product.count).toFixed());
                    }
                })

                stock.ProductSetList.forEach(setItem => {
                    setItem.productList?.forEach(product => {
                        const priceIndex = product.priceListIndex
                        amount += parseFloat(parseFloat(product.priceList[priceIndex].UoMPrice).toFixed(2) * parseFloat(product.count).toFixed());
                        profit += parseFloat(parseFloat(product.recommendPrice).toFixed(2) * parseFloat(product.count).toFixed());
                        if(product.recommendPrice !== 0){
                            amountWithRecPrice += parseFloat(parseFloat(product.priceList[priceIndex].UoMPrice).toFixed(2) * parseFloat(product.count).toFixed());
                        }
                    })
                })


            });


            setAllProductPriceAmount(amount.toLocaleString('uk-UA', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }))
            setAllProductProfit((profit - amountWithRecPrice).toLocaleString('uk-UA', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }))
        }
    }, [cart]);

    const footerContent = (
        <div style={{width:'100%'}}>
            <Button label="Ок" style={{width:'100%'}} onClick={() => handleClose()} autoFocus />
        </div>
    );

    const footerContentForDiscountModal = (
        <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', marginTop:'10px', padding:0}}>
            <Button label="Так (Повернутись до каталогу)" onClick={navigateToCatalog} severity="info"  />
            <Button label="Ні (Оформити замовлення)" onClick={createSalesOrderWithoutDiscount}  />
        </div>
    )

    const clearCartConfirmRenderFooter = () => {
        return (
            <div style={{display:"flex", justifyContent: "flex-end"}}>
                <Button style={{margin:'3px', borderRadius:'5px' }} severity="danger" label="Так" icon="pi pi-check" onClick={acceptClearCart} />
                <Button style={{margin:'3px', borderRadius:'5px'}} label="Ні" icon="pi pi-times" onClick={() => {setClearCartConfirmVisible(false)}} className="p-button-secondary" />
            </div>
        );
    };

    const acceptClearCart = async () => {
        clearCart().then(() => setClearCartConfirmVisible(false));
    }

    const headerPanelTemplate = (options, item) => {

        const className = `${options.className}`;
        let wrapperStyle = {display:'grid',  width:'100%',gridGap:'10px'};
        let headerStyle = {display: 'flex', justifyContent:'space-between', gridGap:'10px'};

        return (
            <div className={`${className}`}>
                <div style={wrapperStyle}>
                    <div style={headerStyle}>
                        <div style={{alignSelf:"center"}}>
                        <Tag severity="info" value="Акція" style={{alignSelf: 'center', justifySelf: "start", marginRight: '10px'}}
                             rounded></Tag>
                        <span style={{fontWeight: '600', alignSelf: 'center'}}>{item.Name}</span>
                        </div>
                        <span style={{alignSelf: "start", justifySelf: "end"}}>{options.togglerElement}</span>
                    </div>
                </div>
            </div>
        )
    }

    if(isFirstLoading){
        return (
            <div className={styles.spinner}> <SpinnerUA /> </div>
        )
    }

    if (products.length === 0 && stockList.length === 0 && !isLoading) {

        return (<div style={{height:'100vh', display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center", padding: '20px'}} >
                    <h2 style={{margin:'auto'}}>Кошик порожній, будь ласка, додайте товари в кошик з каталогу товарів або акцій</h2>
               </div>)
    }

    return (
        <div className={styleCart.pageWrapper}>
            <div className={styleCart.cartWrapper}>
                <ConfirmPopup target={clearCartBtn.current} style={{borderRadius:'5px'}}  dismissable={false} footer={clearCartConfirmRenderFooter} visible={clearCartConfirmVisible} onHide={() => setClearCartConfirmVisible(false)}
                              message="Ви впевнені, що хочете очисти кошик?" icon="pi pi-exclamation-triangle" />
            <div style={{display:"flex", justifyContent:"flex-end"}}>
                <Button ref={clearCartBtn} label="Очистити кошик" severity="danger" style={{borderRadius:'8px'}} onClick={() => setClearCartConfirmVisible(true)}  />
            </div>
            <div className='cartWarningMessageWrapper'>
                <Messages onClick={() => navigate("/history")}   ref={msgs} />
            </div>

            {productAvailabilityList && productAvailabilityList.length > 0 &&
                (
                    <div ref={balanceMessageRef} className={classNames('custom-warning')}>
                    {/* <i className="pi pi-exclamation-triangle custom-warning-icon" /> */}
                    <div style={{display:"flex", gap: '10px'}}>
                        <span style={{fontSize:'1rem'}}>🔔</span>
                        <div className='ml-2'> Зверніть увагу!</div>
                    </div>
                    <div >Деякі товари з вашого замовлення наразі доступні в меншій кількості, ніж ви вказали:</div>
                    <div>
                        {productAvailabilityList.map((productAvailabilityRecord, index) => {
                            return(
                            <li key={productAvailabilityRecord.Id + index}>{productAvailabilityRecord.Name} — в кошику: {productAvailabilityRecord.InCartCount} шт, <b> доступно  {productAvailabilityRecord.Balance} шт</b></li>
                        )})}
    
                    </div>
                  </div>
                )
            }
            

            <Toast style={{zIndex:'1000'}} ref={toast}></Toast>
            <ConfirmPopup />
            {isVisible ? 
            
                <div >
                    {products.length > 0 ? <div className={styleCart.panelWrapper}>
                        <Panel header="Базове замовлення" toggleable>
                        <DiscountProgressBar/>
                            <div className={styleCart.cardGroup}>
                                {
                                    products.map(p => <CartProductNew
                                            id={p.id}
                                            stockId={null}
                                            discountLabel={discountLabel}
                                            name={p.name}
                                            number={p.number}
                                            recommendPrice={p.recommendPrice}
                                            priceList={p.priceList}
                                            calcPrice={p.calcPrice}
                                            priceListIndex={p.priceListIndex}
                                            count={p.count}
                                            key={p.id}
                                            isDiscount={p.isDiscount}
                                            goalAchieved={isDiscountGoalAchieved}
                                            isLoading={isLoading}
                                            setIsLoading = {setIsLoading}
                                            urls={p.smallImageUrlList}
                                            isBalanceEnds={p.IsBalanceEnds}
                                            toast={toast}
                                        />
                                    )
                                }
                            </div>
                        </Panel>
                    </div> : null}

                    {stockList.map((stock) =>
                        <div key ={stock.Id} className={styleCart.panelWrapper}>

                        <Panel headerTemplate={options => headerPanelTemplate(options, stock)} toggleable>
                            {stock.IsSet !== true ?
                                <div>
                                    {stock.MarketingStockTypeId && stock.MarketingStockTypeId === MarketingStockTypesEnum.calculating && !stock.CalculatorModel?.IsConditionFulfilled ? <span style={{color:'#da2222'}}>Замовлення не буде створено, якщо умови акції не виконані</span>: null}
                                    <MarketingStockCalculator stockId={stock.Id} />
                                    <CardGroup className={styleCart.cardGroup}>
                                        {
                                            stock.ProductList.map(p => <CartProductNew
                                                    id={p.id}
                                                    stockId={stock.Id}
                                                    discountLabel={discountLabel}
                                                    name={p.name}
                                                    number={p.number}
                                                    recommendPrice={p.recommendPrice}
                                                    priceList={p.priceList}
                                                    calcPrice={p.calcPrice}
                                                    productPrice={p.productPrice}
                                                    productStockPrice={p.productStockPrice}
                                                    priceListIndex={p.priceListIndex}
                                                    count={p.count}
                                                    key={p.id}
                                                    isDiscount={p.isDiscount}
                                                    isLoading={isLoading}
                                                    setIsLoading = {setIsLoading}
                                                    urls={p.smallImageUrlList}
                                                    isBalanceEnds={p.IsBalanceEnds}
                                                    toast={toast}
                                                />
                                            )
                                        }
                                    </CardGroup>
                                </div>
                            : stock.ProductSetList.map((setItem, index) =>
                                <CartStockSetItem stock={stock} key={setItem.id + index} setItem={setItem} toast={toast} isLoading={isLoading} setIsLoading = {setIsLoading} discountLabel={discountLabel} />
                            )} 
                        </Panel>
                    </div>
                    )}
                </div>
                
            : null}

                <div className={styleCart.all}>

                    <div className={`${styleCart.block1} block1`}>


                        <FloatLabel>
                            <Calendar className={styleCart.inputField} value={requestDeliveryBy}
                                      onChange={(e) => reqDelByHandler(e)} minDate={minDate} disabledDays={[0, 6]}
                                      locale="uk" dateFormat="dd.mm.yy" showButtonBar showIcon/>
                            <label htmlFor="username">Дата поставки</label>
                        </FloatLabel>

                        <FloatLabel>
                            <Dropdown value={selectedAccountDeliveryAddress} onChange={deliveryAddressHandler}
                                      options={accountDeliveryAddressList} style={{borderRadius: '9px', width:'100%'}}
                                      optionLabel="FullName"
                                      placeholder="" className={styleCart.inputField}/>
                            <label htmlFor="FullName">Адреса доставки</label>
                        </FloatLabel>

                        <FloatLabel>
                            <Dropdown value={accountingType} onChange={accountingTypeHandler}
                                      options={accountingTypeList} style={{borderRadius: '9px'}} optionLabel="Label"
                                      placeholder="" className={styleCart.inputField}/>
                            <label htmlFor="username">Спосіб оплати</label>
                        </FloatLabel>

                    </div>

                    <div className={styleCart.sum}>

                        <div className={`${styleCart.inputWrapper}`}>
                            <span className={`${styleCart.inputDescription} `}>Загальна ціна</span>
                            <div
                                className={`${styleCart.input} ${styleCart.justifySelfEnd} ${styleCart.alignSelfCenter}`}>
                                {allProductPriceAmount} грн
                            </div>
                        </div>

                        <div className={`${styleCart.inputWrapper}`}>
                            <span className={`${styleCart.inputDescription} `}>Приблизний прибуток</span>
                            <div
                                className={`${styleCart.input} ${styleCart.justifySelfEnd} ${styleCart.alignSelfCenter} ${styleCart.greenForestColor}`}>
                                {allProductProfit} грн
                            </div>
                        </div>

                        <div className={`${styleCart.inputWrapper}`}>
                            <span style={{display:"flex", alignItems:"center"}}>
                                <span className={`${styleCart.inputDescription} `}>Економія</span><Tooltip
                                target=".pi-info-circle"/><i style={{marginLeft: '5px', fontSize:'1.2rem'}}
                                                             data-pr-tooltip="Сума, яку Ви заощадите, купуючи товари зі знижкою"
                                                             data-pr-position="bottom" className="pi pi-info-circle"
                                                             rounded severity="secondary" aria-label="Bookmark"></i>
                            </span>

                            <div
                                className={`${styleCart.input} ${styleCart.justifySelfEnd} ${styleCart.alignSelfCenter}`}>
                                {saveAmount.toLocaleString('uk-UA', {
                                    style: 'decimal',
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2 })} грн
                            </div>
                        </div>

                    </div>

                </div>

                <div className={` ${styleCart.noteWrapper}`}>
                    <span className="p-float-label">
                        <InputTextarea className={styleCart.noteWrapper}  value={note} onChange={(e) => setNote(e.target.value)}  rows={3} />
                        <label htmlFor="description">Якщо у Вас є побажання, ми готові Вас вислухати :)</label>
                    </span>
                </div>


            <button  disabled={isLoading} onClick={createSalesOrderButtonClickHandler} className={styleCart.createSalesOrderButton}>
                Створити замовлення
            </button>
            {isLoading?  <div className={styles.spinner}>
                <SpinnerUA />

            </div>: null}
            <div className="card flex justify-content-center">
                <Dialog header="Відповідь сервера" visible={show} className={styleCart.cartServerResponseModal} footer={footerContent} onHide={() => handleClose()}>
                    <p className={styleCart.cartServerResponseModalContent}>
                        <div dangerouslySetInnerHTML={{ __html: crmMessage }}></div>
                    </p>
                </Dialog>
            </div>
                <Dialog header={<span>Бажаєш знижку {discountPercent}?</span>} visible={discountModalVisible} className={styleCart.cartAlertModal} footer={footerContentForDiscountModal}  onHide={() => handleCloseDiscountModal()}>
                <p className={styleCart.cartAlertModalContent}>
                    <div>Доповни замовлення на <b>{countLitersToDiscount}л</b> за продуктами з позначкою "-{discountPercent}" </div>
                </p>
            </Dialog>
            </div>
        </div>
    )
}